import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";

class UserProfileService {
  config = {
    headers: {
      Authorization: "",
      CompanyId: "",
    },
  };

  //set access token
  setAccessToken(accessToken, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.CompanyId = companyId;
  }

  //get user profile by user detail id
  async getUserProfileByUserDetailsId(userDetailsId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(
      `/api/userDetails/${userDetailsId}`,
      this.config
    );
    return res.data;
  }

  //upload profile picture
  async uploadProfilePicture(profilePicture, userDetailsId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(
      `/api/userDetails/uploadProfilePicture/profile`,
      profilePicture,
      this.config
    );
    return res.data;
  }

  //delete profile picture
  async deleteProfilePicture(userDetailsId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.delete(
      `/api/userDetails/deleteProfilePicture`,
      this.config
    );
    return res;
  }

  //get profile picture
  async getProfilePictureByUserDetailsId(userDetailsId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(
      `/api/userDetails/profilePicture/${userDetailsId}`,
      this.config
    );
    return res.data;
  }

  //update user profile
  async updateUserProfile(formData, userDetailsId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.put(
      `/api/userDetails/updateUserProfile`,
      formData,
      this.config
    );
    return res.data;
  }

  async changeUserPassword(formData, userId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(
      `/api/userDetails/changePassword`,
      formData,
      this.config
    );
    return res;
  }

  //get two factor status
  async getTwoFactorStatus(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(
      `/api/user/2fa`,
      this.config
    );
    return res.data;
  }

  async updateTwoFactorStatus(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(
      `/api/user/2fa`,
      formData,
      this.config
    );
    return res;
  }

  async resetPassword(formData, userDetailsId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(
      `/api/userDetails/resetPassword/${userDetailsId}`,
      formData,
      this.config
    );
    return res;
  }

};
export default new UserProfileService();